import React, {useEffect, useState, useCallback, useMemo  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"
import { setFilters, resetFilters} from 'reducers/filtersStoresSlice';
import { resetPagination } from 'reducers/paginationStoresSlice';
import { useNavigate } from 'react-router-dom';
import { LIMIT_PAGE_SIZE, ENDPOINT,NON_ERASABLE_STORE_ID, DELETE_CODE, DELETE_CODE_STORE } from "constants/variables";
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingStore from 'pages/stores/storesFilterList/SortingTablesStore';   
import PropTypes from 'prop-types';


const initialFiltersStore= {
  "idFrom":"",
  "idTo":"",
  "documentIdFrom":"",
  "documentIdTo":"",
  "tradenameFrom":"",
  "tradenameTo":"",
  "nameFrom":"",
  "nameTo":"",
  "contacpersonFrom":"",
  "contacpersonTo":"",
  "enabled":true,
  "notenabled":true,
  "emailsFrom":"",
  "emailsTo":"",
  "phonesFrom":"",
  "phonesTo":""
};
 
const initialStateStore = [{
  "id":"",
  "documentid":"",
  "tradename":"",
  "name":"",
  "contacperson":"",
  "contacphone":"",
  "contacemail":"",
  "endpoint":"",
  "bucket":"",
  "createdate":"",
  "comments":"",
  "enabled" : true,
  "useraccounts":[]
}];
             
const StoresFilter = ({ showModalStoreSettings, setShowModalStoreSettings}) => {  
  const {t,i18n} = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const [dataStore, setDataStore] = useState(initialStateStore);
  const filtersStoresDetails = useSelector((state) => state.filtersStores);
  const [filtersStore, setFiltersStore]= useState(filtersStoresDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegStore,setNumTotRegStore]= useState(0);
  const [errorsFiltersStore, setErrorsFiltersStore] = useState({});
  const [inputTextStore, setInputTextStore] = useState(""); 
  const [openCreateDataStore,setOpenCreateDataStore]= useState(false);
  const [openDeleteRowStore,setOpenDeleteRowStore]= useState(false);
  const [openEditRowStore,setOpenEditRowStore]= useState(false);
  const [openEditFilterStore,setOpenEditFilterStore]= useState(false);
  const [rowEditStore,setRowEditStore]= useState(initialStateStore[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorStore, setIsLoadingErrorStore] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffsetStore, setActiveOffsetStore]= useState(false);
  const [currencyOffsetStore, setCurrencyOffsetStore] = useState(0);
  const [rangeOffsetStore, setRangeOffsetStore] = useState([{}]);

  const menuPermissions = useMemo(() => {
  const list = roles && roles[0] && roles[0].listmenus ? roles[0].listmenus : [];
  const has = (name) => list.some((m) => m.name === name);
    return {
      canCreate: has('SubMenu_Stores_Create'),
      canEdit: has('SubMenu_Stores_Edit'),
      canDelete: has('SubMenu_Stores_Delete'),
    };
  }, [roles]);

  const navigate = useNavigate(); 

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalStoreSettings) {
        setDataStore(initialStateStore); 
        setNumTotRegFilter(0);
        setNumTotRegStore(0);
        setErrorsFiltersStore({});
        setInputTextStore(""); 
        setOpenCreateDataStore(false);
        setOpenDeleteRowStore(false);
        setOpenEditRowStore(false);
        setOpenEditFilterStore(false);
        setRowEditStore(initialStateStore[0]); 
        setIsLoadingErrorStore(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffsetStore(false);
        setCurrencyOffsetStore(0);
        setRangeOffsetStore([{}]);
        setShowModalStoreSettings(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters()); 
        setFiltersStore(initialFiltersStore);
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataStore,
      setFiltersStore,
      setNumTotRegFilter,
      setNumTotRegStore,
      setErrorsFiltersStore,
      setInputTextStore, 
      setOpenCreateDataStore,
      setOpenDeleteRowStore,
      setOpenEditRowStore,
      setOpenEditFilterStore,
      setRowEditStore, 
      setIsLoadingErrorStore,
      setIdCodeDelete,
      setActiveOffsetStore,
      setCurrencyOffsetStore,
      setRangeOffsetStore, 
      showModalStoreSettings, 
      setShowModalStoreSettings,
      dispatch,
      navigate]
  );
  
  const closeModalStores = () => {    
    setDataStore(initialStateStore); 
    setNumTotRegFilter(0);
    setNumTotRegStore(0);
    setErrorsFiltersStore({});
    setInputTextStore(""); 
    setOpenCreateDataStore(false);
    setOpenDeleteRowStore(false);
    setOpenEditRowStore(false);
    setOpenEditFilterStore(false);
    setRowEditStore(initialStateStore[0]); 
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffsetStore(false);
    setCurrencyOffsetStore(0);
    setRangeOffsetStore([{}]);
    setShowModalStoreSettings(false); 
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersStore(initialFiltersStore);
    navigate("/home");
    return () => {};
  };

  const openCreateOrEditDataStore = () => {
    setInputTextStore(""); 
    setOpenCreateDataStore(true);
    navigate("/storedetail/0"); 
  };
  
  const openEditFiltersStore = () => { 
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleSubmitFilterEditStore = () => {
    setErrorsFiltersStore(validateFormFilterStore());
    if (Object.keys(errorsFiltersStore).length === 0) {
      setErrorsFiltersStore({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersStore));  
      setOpenEditFilterStore(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersStore = () => {
    setErrorsFiltersStore({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersStore(initialFiltersStore);
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleCancelFiltersStore = () => {
    setErrorsFiltersStore({});
    setOpenEditFilterStore(!openEditFilterStore);
  };

  const handleChangeEnabledFilter = (e) => {
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      enabled: !filtersStore.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      notenabled: !filtersStore.notenabled
    }));
  };

  const handleChangeFilterEditStore = (e) => {
    const { name, value } = e.target;
    setFiltersStore(filtersStore => ({
      ...filtersStore,
      [name]: value
    }));
  };

  const handleBlurFilterEditStore = (e) => {
    setErrorsFiltersStore(validateFormFilterStore());
    handleChangeFilterEditStore(e);
  };

  const toggleDrawerFilterEditStore = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditStore();
    }
  };

  const validateFormFilterStore = () => {

    let errorsFiltersStore = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersStore.idFrom!=="" & !regexNumber.test(filtersStore.idFrom)) {
      errorsFiltersStore.idFrom = 'Text_TextNoNumber';
    }
    if (filtersStore.idTo!=="" & !regexNumber.test(filtersStore.idTo)) {
      errorsFiltersStore.idTo = 'Text_TextNoNumber';
    }
    if (filtersStore.idFrom!=="" & !errorsFiltersStore.idFrom!==undefined){
      if (filtersStore.idTo!=="" & !errorsFiltersStore.idTo!==undefined){
        if (parseInt(filtersStore.idTo)<parseInt(filtersStore.idFrom)){
          errorsFiltersStore.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersStore.documentIdFrom)) {
      errorsFiltersStore.documentIdFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.documentIdTo)) {
      errorsFiltersStore.documentIdTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.tradenameFrom)) {
      errorsFiltersStore.tradenameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.tradenameTo)) {
      errorsFiltersStore.tradenameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.nameFrom)) {
      errorsFiltersStore.nameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.nameTo)) {
      errorsFiltersStore.nameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.contacpersonFrom)) {
      errorsFiltersStore.contacpersonFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.contacpersonTo)) {
      errorsFiltersStore.contacpersonTo = 'Text_TextNoValid';
    } 
    
    if (regexInvalidCharacters.test(filtersStore.emailsFrom)) {
      errorsFiltersStore.emailsFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.emailsTo)) {
      errorsFiltersStore.emailsTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.phonesFrom)) {
      errorsFiltersStore.phonesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersStore.phonesTo)) {
      errorsFiltersStore.phonesTo = 'Text_TextNoValid';
    } 
    if (filtersStore.documentIdTo!=="" & filtersStore.documentIdTo<filtersStore.documentIdFrom){
      errorsFiltersStore.documentIdTo = 'Text_TextGreater_documentid';
    }
    if (filtersStore.tradenameTo!=="" & filtersStore.tradenameTo<filtersStore.tradenameFrom){
      errorsFiltersStore.tradenameTo = 'Text_TextGreater_tradename';
    }
    if (filtersStore.nameTo!=="" & filtersStore.nameTo<filtersStore.nameFrom){
      errorsFiltersStore.nameTo = 'Text_TextGreater_name';
    }
    if (filtersStore.contacpersonTo!=="" & filtersStore.contacpersonTo<filtersStore.contacpersonFrom){
      errorsFiltersStore.contacpersonTo = 'Text_TextGreater_contactName';
    } 
    if (filtersStore.emailsTo!=="" & filtersStore.emailsTo<filtersStore.emailsFrom){
      errorsFiltersStore.emailsTo = 'Text_TextGreater_emails';
    }

    if (filtersStore.phonesTo!=="" & filtersStore.phonesTo<filtersStore.phonesFrom){
      errorsFiltersStore.phonesTo = 'Text_TextGreater_phones';
    }
    return errorsFiltersStore;
  }  

  const filteredDataStore = dataStore.filter((el) => {
    if (inputTextStore === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.documentid || '') +
        String(el.tradename || '') +
        String(el.contacperson || '') +
        String(el.cnae || '') +
        String(el.contacemail || '') +
        String(el.endpoint || '');
      let result = dataTranslate.toLowerCase().includes(inputTextStore.toLowerCase());
      return result;
    }
  })

 
  let inputHandlerStore = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextStore(lowerCase);
  };
  
  const handleChangeDeleteRowStore = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };
  
  const handleCancelDeleteRowStore = () => {
    setRowEditStore(initialStateStore[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowStore(false);
  };

  const handleCloseDeleteRowStore = (e) => {
    if (idCodeDelete !== DELETE_CODE_STORE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditStore.id !== '') {
     
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `store/deletestore`, token, rowEditStore);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          } 
        }; 
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIsLoadingErrorStore(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowStore(false);
    handleCloseDataEditStore();
    return () => { isMounted = false;};
  };
 
  const handleCloseDataEditStore = () => { 
    setOpenCreateDataStore(false);
    setOpenEditRowStore(false);
    setRowEditStore(openEditRowStore?rowEditStore:initialStateStore[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorStore(false);
    toggleDrawerFilterEditStore(false);
	};

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegStore > LIMIT_PAGE_SIZE) {
      setActiveOffsetStore(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE_SIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE_SIZE); i < numTotRegStore; i += Number(LIMIT_PAGE_SIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE_SIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetStore(newRangeOffset);
    } else {
      setCurrencyOffsetStore(0);
      setActiveOffsetStore(false);
      setRangeOffsetStore([{}]);
    }
  }, [numTotRegStore]);

  useEffect(() => {
    let isMounted = true;
    const fetchnumTotReg = async () => { 
      try {
        const getData = await helpHttp().get(ENDPOINT, `store/getinformationtablestore`, token);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataStore(initialStateStore);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegStore(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `store/getcountfilterstore`, token, filtersStoresDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataStore(initialStateStore);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchDataStore = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `store/simplestores`, token, currencyOffsetStore, LIMIT_PAGE_SIZE, filtersStoresDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataStore(initialStateStore);
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setDataStore(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (showModalStoreSettings) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchDataStore();
    }
    return () => { isMounted = false; };

  }, [t,i18n,token,dispatch,openCreateDataStore,openDeleteRowStore,setOpenDeleteRowStore,rowEditStore,showModalStoreSettings,filtersStoresDetails,currencyOffsetStore]);
 
  return (
    <>
      {showModalStoreSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorStore?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowStore?"warning":"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_Stores_Table')}
            </h1>
            {menuPermissions.canCreate ? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditDataStore} >
                  {t('Button_Create')}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalStores} >
                  {t('Button_Back')}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalStores} >
                  {t('Button_Back')}
                </button>
              </div>
            )} 
          </div>  
          <br/>  
      
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              value={inputTextStore}
              placeholder={t('Text_Store_Search')} 
              onChange={inputHandlerStore}
              fullWidth
              label={t('Text_Store_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.idFrom !== "" || filtersStoresDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.idFrom !== "" || filtersStoresDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.tradenameFrom !== "" || filtersStoresDetails.tradenameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.tradenameFrom !== "" || filtersStoresDetails.tradenameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_tradename")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.documentIdFrom !== "" || filtersStoresDetails.documentIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.documentIdFrom !== "" || filtersStoresDetails.documentIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_documentid")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.nameFrom !== "" || filtersStoresDetails.nameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.nameFrom !== "" || filtersStoresDetails.nameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_name")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.contacpersonFrom !== "" || filtersStoresDetails.contacpersonTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.contacpersonFrom !== "" || filtersStoresDetails.contacpersonTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_contacperson")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.enabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.enabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_enabled_Upper")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersStoresDetails.notenabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersStore} >
                <span className={`formdi-pending-dot ${ filtersStoresDetails.notenabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_disabled")}
              </button>  
            </div>
          </div>
          <br/>   

          {!isLoadingData ?
            <>
              <div className="card shadow mb-4">    
                <div className="card-body">
                  <TableSortingStore
                    dataStore={filteredDataStore}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={t('Text_Stores_Table')}
                    setOpenDeleteRowStore={setOpenDeleteRowStore}
                    setRowEditStore={setRowEditStore}
                    showEditButtonStore={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Stores_Edit'))?true:false}
                    showDeleteButtonStore={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Stores_Delete'))?true:false}
                    numTotRegStore={numTotRegStore}
                    activeOffsetStore={activeOffsetStore}
                    rangeOffsetStore={rangeOffsetStore}
                    currencyOffsetStore={currencyOffsetStore}
                    setCurrencyOffsetStore={setCurrencyOffsetStore}
                    minvalue={Number(NON_ERASABLE_STORE_ID)}>
                  </TableSortingStore>
                </div>             
              </div>
              {openEditFilterStore &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditStore(false)}
                 onOpen={toggleDrawerFilterEditStore(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfilteemployee" onSubmit={handleCancelFiltersStore}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filtersStore.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.idFrom!=null?t(errorsFiltersStore.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersStore.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.idTo!=null?t(errorsFiltersStore.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                           </div>
                           <div className="form-group">
                            <TextField
                              id="documentIdFrom" 
                              name="documentIdFrom"
                              value={filtersStore.documentIdFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.documentIdFrom!=null?t(errorsFiltersStore.documentIdFrom):t('Text_Filter_documentId_From')}
                              placeholder={t('PlaceHolder_Filter_documentid_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="documentIdTo" 
                              name="documentIdTo"
                              value={filtersStore.documentIdTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.documentIdTo!=null?t(errorsFiltersStore.documentIdTo):t('Text_Filter_documentId_To')}
                              placeholder={t('PlaceHolder_Filter_documentid_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                           <div className="form-group">
                            <TextField
                              id="tradenameFrom" 
                              name="tradenameFrom"
                              value={filtersStore.tradenameFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.tradenameFrom!=null?t(errorsFiltersStore.tradenameFrom):t('Text_Filter_tradename_From')}
                              placeholder={t('PlaceHolder_Filter_tradename_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="tradenameTo" 
                              name="tradenameTo"
                              value={filtersStore.tradenameTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.tradenameTo!=null?t(errorsFiltersStore.tradenameTo):t('Text_Filter_tradename_To')}
                              placeholder={t('PlaceHolder_Filter_tradename_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                          <div className="form-group">
                            <TextField
                              id="nameFrom" 
                              name="nameFrom"
                              value={filtersStore.nameFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.nameFrom!=null?t(errorsFiltersStore.nameFrom):t('Text_Filter_name_From')}
                              placeholder={t('PlaceHolder_Filter_name_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                            <TextField
                              id="nameTo" 
                              name="nameTo"
                              value={filtersStore.nameTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.nameTo!=null?t(errorsFiltersStore.nameTo):t('Text_Filter_name_To')}
                              placeholder={t('PlaceHolder_Filter_name_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                          <div className="form-group">
                            <TextField
                              id="contacpersonFrom" 
                              name="contacpersonFrom"
                              value={filtersStore.contacpersonFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.contacpersonFrom!=null?t(errorsFiltersStore.contacpersonFrom):t('Text_Filter_contactName_From')}
                              placeholder={t('PlaceHolder_Filter_contactName_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="contacpersonTo" 
                              name="contacpersonTo"
                              value={filtersStore.contacpersonTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.contacpersonTo!=null?t(errorsFiltersStore.contacpersonTo):t('Text_Filter_contactName_To')}
                              placeholder={t('PlaceHolder_Filter_contactName_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div> 
                          <div className="form-group">
                            <TextField
                              id="emailsFrom" 
                              name="emailsFrom"
                              value={filtersStore.emailsFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.emailsFrom!=null?t(errorsFiltersStore.emailsFrom):t('Text_Filter_emails_From')}
                              placeholder={t('PlaceHolder_Filter_emails_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="emailsTo" 
                              name="emailsTo"
                              value={filtersStore.emailsTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.emailsTo!=null?t(errorsFiltersStore.emailsTo):t('Text_Filter_emails_To')}
                              placeholder={t('PlaceHolder_Filter_emails_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                          <div className="form-group">
                            <TextField
                              id="phonesFrom" 
                              name="phonesFrom"
                              value={filtersStore.phonesFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsFiltersStore.phonesFrom!=null?t(errorsFiltersStore.phonesFrom):t('Text_Filter_phones_From')}
                              placeholder={t('PlaceHolder_Filter_phones_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="phonesTo" 
                              name="phonesTo"
                              value={filtersStore.phonesTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFiltersStore.phonesTo!=null?t(errorsFiltersStore.phonesTo):t('Text_Filter_phones_To')}
                              placeholder={t('PlaceHolder_Filter_phones_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditStore}
                              onChange={handleChangeFilterEditStore}/>
                          </div>
                           
                          <div className="form-group">
                            <Checkbox
                              id="enabled" 
                              name="enabled"
                              checked={filtersStore.enabled}
                              onChange={handleChangeEnabledFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Habilty')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Checkbox
                              id="notenabled" 
                              name="notenabled"
                              checked={filtersStore.notenabled}
                              onChange={handleChangeNotEnabledFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Not_Habilty')}</label>    
                          </div> 
                         </div>
                         <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditStore}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersStore}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
             </div>
              }  
              <Dialog open={openDeleteRowStore} onClose={handleCancelDeleteRowStore} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t('Text_Delete')} {rowEditStore.id}  - {rowEditStore.tradename}
                </DialogTitle>
                  <DialogContent>
                    <DialogContentText className="my-dialog-contentText-danger">
                      {t("Text_Line1")}<br />
                      {t("Text_Line2")}
                    </DialogContentText>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="idCode"
                        label={t("Text_Label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        className="my-dialog-input-danger"
                        defaultValue={idCodeDelete}
                        onChange={handleChangeDeleteRowStore}
                      />
                    </DialogContent>
                  <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowStore}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowStore}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog>    
              {/* End Content Row */}
            </>:
              <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

StoresFilter.propTypes = {
  showModalStoreSettings: PropTypes.bool.isRequired,
  setShowModalStoreSettings: PropTypes.func.isRequired
};

export default StoresFilter;